import { createFileRoute } from '@tanstack/react-router';

import { WorkbenchActions } from '@/features/workbench/WorkbenchActions';
import { PlainLayout } from '@/modus/PlainLayout';
import { Wordmark } from '@/modus/Wordmark';

export const Route = createFileRoute('/_protected/t/$tenantId/workbench/')({
  component: WorkbenchRoute,
});

function WorkbenchRoute() {
  return (
    <PlainLayout className="relative flex size-full flex-col items-center justify-center gap-8">
      <title>Workbench</title>
      <Wordmark size={132} orientation="vertical" />
      <WorkbenchActions />
    </PlainLayout>
  );
}
